import { Extension } from "@tiptap/core";

export const GlobalAttributes = Extension.create({
	name: "globalAttributes",

	addGlobalAttributes() {
		return [
			{
				types: [
					"paragraph",
					"heading",
					"listItem",
					"bulletList",
					"blockquote",
					"codeBlock",
					"image",
					"flexBox",
					"gridBox",
				],
				attributes: {
					style: {
						default: null,
						parseHTML: (element) => element.getAttribute("style"),
						renderHTML: (attributes) =>
							attributes.style ? { style: attributes.style } : {},
					},
					class: {
						default: null,
						parseHTML: (element) => element.getAttribute("class"),
						renderHTML: (attributes) =>
							attributes.class ? { class: attributes.class } : {},
					},
				},
			},
		];
	},
});
